import React from 'react'


class Breadcrumb extends React.Component {

    render() {
        return (

            <>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        {
                            this.props.breadcrumb.map((item, index) => (

                                <li className={`breadcrumb-item${!item.url ? ' active' : ''}`} key={index}>
                                    {
                                        item.url ? (
                                            <a href={item.url}>{item.title}</a>
                                        ) : item.title
                                    }
                                </li>

                            ))
                        }
                    </ol>
                </nav>
            </>

        )
    }

}

export default Breadcrumb;